export default __webpack_public_path__ + "static/media/32t.074d6173.jpg";